import React from 'react';
import { MdAccessTime, MdSportsFootball } from 'react-icons/md';

const Sort = ({ onClose, onSortingSelection }) => {

  const handleSortByChange = (value) => {
    onSortingSelection(value);
    onClose();
  };

  return (
    <div className="min-w-[200px]">
      {/* Header */}
      <div className="mb-3">
        <h3 className="text-lg font-bold text-[#228B22] flex items-center gap-2">
          <div className="w-2 h-2 bg-[#FFD700] rounded-full animate-pulse"></div>
          Sort Options
        </h3>
      </div>

      {/* Sort Options */}
      <div className="space-y-2">
        <button
          className="w-full flex items-center gap-3 p-3 rounded-xl bg-gradient-to-r from-[#228B22]/10 to-emerald-50 hover:from-[#228B22]/20 hover:to-emerald-100 border border-[#228B22]/20 hover:border-[#228B22]/40 transition-all duration-200 group"
          onClick={() => handleSortByChange('eventTime')}
        >
          <div className="p-2 bg-[#1E90FF]/20 rounded-lg group-hover:bg-[#1E90FF]/30 transition-colors">
            <MdAccessTime size={18} className="text-[#1E90FF]" />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-gray-800">Sort by Time</p>
            <p className="text-xs text-gray-600">Earliest matches first</p>
          </div>
        </button>

        <button
          className="w-full flex items-center gap-3 p-3 rounded-xl bg-gradient-to-r from-[#FFD700]/10 to-yellow-50 hover:from-[#FFD700]/20 hover:to-yellow-100 border border-[#FFD700]/30 hover:border-[#FFD700]/50 transition-all duration-200 group"
          onClick={() => handleSortByChange('leagueName')}
        >
          <div className="p-2 bg-[#228B22]/20 rounded-lg group-hover:bg-[#228B22]/30 transition-colors">
            <MdSportsFootball size={18} className="text-[#228B22]" />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-gray-800">Sort by League</p>
            <p className="text-xs text-gray-600">Alphabetical order</p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Sort;
